<template>
  <div
    class="more-about-event">
    <div class="header">
      <i
        class="icon-arrow-left"
        @click="goToEvents"/>
    </div>
    <div
      :style="backgroundImg"
      class="background-img">
      <div class="event-icon">
        <i
          v-if="category === 3 "
          class="icon-music-icon music-category background-category"/>
        <i
          v-else-if="category === 4 "
          class="icon-sports-icon sports-category background-category"/>
        <i
          v-else-if="category === 5 "
          class="icon-arts-icon arts-category background-category"/>
        <i
          v-else-if="category === 6 "
          class="icon-kids-icon kids-category background-category "/>
        <i
          v-else-if="category === 7 "
          class="icon-special-icon special-category background-category"/>
      </div>
    </div>
    <div class="content-about-event">
      <h1>{{ data.name }}</h1>
      <p v-html="data.description"/>
      <el-col>
        <b class="title-participe">Participan</b>
        <br>
        <br>
        <div
          v-for="artist in artistMore"
          :key="artist.id"
          class="artist-participe"
          @click="goToArtist(artist.id)">
          <div
            :style="{backgroundImage: `url(${artist.profileImage})`}"
            class="profile-img-artist"/>
          <span class="name-artist">{{ artist.artistName }}</span>
        </div>
      </el-col>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MoreAboutEvent',
  props: {
    data: {
      type: Object,
      required: true
    },
    artistMore: {
      type: Array,
      required: true
    },
    category: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      event: {}
    }
  },
  computed: {
    backgroundImg () {
      return {
        backgroundImage: 'url(' + this.data.coverImage + ')'
      }
    },
    eventArtist () {
      return this.$store.getters['eventArtist/items']
    },
    artist () {
      return this.$store.getters['artist/items']
    }
  },
  mounted () {
    this.$store.dispatch('events/get', {id: this.$route.params.id}).then((response) => {
      this.event = response.data
    }).catch((e) => {
    })
  },
  methods: {
    goToEvents () {
      this.$emit('close')
    },
    goToArtist (id) {
      this.$router.push({name: 'Artista', params: {id: id}})
    }
  }
}
</script>

<style lang="scss" scoped>

  .more-about-event {
    margin: 0;
    background-color: #F5F5F5;
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0 !important;
    z-index: 203;
  }

  .header {
    width: 100%;
    height: 50px;
    background-color: $roseHeader;
    display: flex;
    align-items: center;
    i {
      color: white;
      font-size: 22px;
      margin-left: 20px;
    }
  }
  .background-img{
    background-size: cover;
    background-position: center;
    height: 160px;
    position: relative;
    .event-icon{
      position: absolute;
      bottom: 20px;
      left: 20px;
      i{
        color: white;
        font-size: 20px;
        @media #{$iPhoneSE} {
          font-size: 20px;
        }
      }
    }
  }
  .content-about-event{
    padding: 20px;
    h1{
      margin: 0;
    }
  }
  .profile-img-artist {
    background-size: cover;
    height: 30px;
    width: 30px;
    border-radius: 50%;
  }

  .artist-participe {
    display: flex;
    align-items: center;
    cursor: pointer;
    transition: all .3s ease-in-out;
    padding: 5px;
    background-color: white;
    border-radius: 4px;
    margin-top: 3px;
    .profile-img-artist {
      width: 30px;
      height: 30px;
      background-size: cover;
      border-radius: 50%;
    }
    .name-artist {
      @include font-primary(14px, regular);
      color: $carbon;
      margin-left: 15px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/events/more-about-event.vue